//Tabs
 $(document).ready(function(){
  $('.tab-content:first-child').show();
  $('.tab-nav-link').bind('click', function(e) {
    $this = $(this);
    $tabs = $this.parent().parent().next();
    $target = $($this.data("target")); // get the target from data attribute
    $this.siblings().removeClass('current');
    $target.siblings().css("display", "none")
      $this.addClass('current');
      $target.fadeIn("fast");
  });
  $('.tab-nav-link:first-child').trigger('click');
}); 

// Hide the extra content initially, using JS so that if JS is disabled, no problemo:
$('.read-more-content').addClass('hide')
$('.read-more-show, .read-more-hide').removeClass('hide')

// Set up the toggle effect:
$('.read-more-show').on('click', function(e) {
    $(this).next('.read-more-content').removeClass('hide');
    $(this).addClass('hide');
    e.preventDefault();
});
// Changes contributed by @diego-rzg
$('.read-more-hide').on('click', function(e) {
    var p = $(this).parent('.read-more-content');
    p.addClass('hide');
    p.prev('.read-more-show').removeClass('hide'); // Hide only the preceding "Read More"
    e.preventDefault();
});

//AOS
$(document).ready(function() {
    var aos = new AOS.init();
});

